import XRsqSwiper from './sqswiper.vue';

export default XRsqSwiper


// WEBPACK FOOTER //
// ./src/components/sqswiper/sqswiperindex.js